import {Component, Input} from '@angular/core';
import {PlayingVenue} from '../../../../../model/masterdata/PlayingVenue';
import {TooltipModule} from 'primeng/tooltip';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-information-presenter',
  standalone: true,
  imports: [
    TooltipModule,
    TranslateModule
  ],
  templateUrl: './information-presenter.component.html',
  styleUrl: './information-presenter.component.scss'
})
export class InformationPresenterComponent
{
  @Input() show = true;
  @Input() oneRow: boolean;
  @Input() showAllInfos: boolean;
  @Input() small = true;

  playingVenueIntern: PlayingVenue;

  @Input() set playingVenue(value: PlayingVenue)
  {
    if (value)
      this.playingVenueIntern = value;
  }

}
